import {cva} from 'class-variance-authority';

export const iconButtonVariants = cva(
  [
    'relative inline-flex items-center justify-center shrink-0',
    'transition-colors duration-150 ease-out outline-none',
    'disabled:opacity-30 disabled:pointer-events-none',
    'focus-visible:shadow-[var(--chekin-shadow-focus)]',
  ],
  {
    variants: {
      size: {
        s: 'w-8 h-8',
        m: 'w-8 h-8',
        l: 'w-[43px] h-[43px]',
        default: 'w-8 h-8',
      },
      shape: {
        rounded: 'rounded-[var(--chekin-radius-input)]',
        circle: 'rounded-full',
      },
      variant: {
        primary:
          'bg-[var(--chekin-color-brand-blue)] text-[var(--chekin-color-white)] hover:brightness-95',
        secondary:
          'border border-[var(--chekin-color-gray-3)] bg-[var(--chekin-color-white)] text-[var(--chekin-color-brand-navy)] hover:bg-[var(--chekin-color-surface-input-empty)]',
        ghost:
          'bg-transparent text-[var(--chekin-color-gray-1)] hover:bg-[var(--chekin-color-surface-input-empty)]',
        destructive:
          'border border-[var(--chekin-color-gray-3)] bg-[var(--chekin-color-white)] text-[var(--error-message-color)] hover:bg-[var(--chekin-red-150)]',
      },
    },
    defaultVariants: {size: 'm', shape: 'rounded', variant: 'secondary'},
  },
);
